import { render, staticRenderFns } from "./tabs-inactivos.vue?vue&type=template&id=6a8d0ad8&scoped=true"
import script from "./tabs-inactivos.vue?vue&type=script&lang=js"
export * from "./tabs-inactivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d0ad8",
  null
  
)

export default component.exports